<template>
  <div>
    <div>
      <div class="row mb-4">
        <div class="col-7">
          <span class="font-weight-bold">
            {{ notificationsGroupDate(this.$vnode.key) }}
          </span>
        </div>
      </div>
    </div>
    <NotificationItem
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      @close="$emit('close')"
    />
  </div>
</template>
<script>
import moment from 'moment';
import NotificationItem from './NotificationItem';

export default {
  components: {
    NotificationItem,
  },
  props: {
    notifications: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    notificationsGroupDate(date) {
      if (moment(date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        return 'TODAY';
      }

      if (
        moment(date).format('YYYY-MM-DD') ===
        moment()
          .subtract('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        return 'YESTERDAY';
      }

      if (moment(date).format('YYYY-MM-DD') !== 'Invalid date') {
        return moment(date).format('MM/DD/YYYY');
      }

      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NotificationGroup.vue